export default __webpack_public_path__ + "static/media/pattern4.d7089884.png";